import React from 'react'
import { Navigate } from 'react-router'
import { useAuthUser } from 'contexts/AuthUserProvider'
import { homeURL, loginURL } from './urls'

const NotAuthenticatedOrGuest: React.FC = ({ children }) => {
  const { authUser, logout } = useAuthUser()

  if (authUser === undefined) {
    return null
  } else if (authUser === null || authUser.isGuest) {
    return <React.Fragment>{children}</React.Fragment>
  } else {
    const redirectURL = homeURL(authUser)
    if (redirectURL) {
      return <Navigate replace to={redirectURL} />
    } else {
      logout()
      return <Navigate replace to={loginURL()} />
    }
  }
}

export default NotAuthenticatedOrGuest